import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "p-m-0" }, "Contextos de traducciones", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" No hay contextos. ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Buscando contextos ")
const _hoisted_5 = { class: "p-fluid" }
const _hoisted_6 = { class: "p-field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "new-context-name" }, "Nombre", -1)
const _hoisted_8 = { class: "p-field p-mb-0 p-pb-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "new-context-key" }, "Key", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DataTable, {
      value: _ctx.contexts,
      rows: 10,
      dataKey: "id",
      rowHover: true,
      loading: _ctx.loading,
      showGridlines: "",
      responsiveLayout: "scroll"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", null, [
            _createVNode(_component_Button, {
              icon: "pi pi-plus",
              label: "Crear contexto",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onEditContext(null)))
            })
          ])
        ])
      ]),
      empty: _withCtx(() => [
        _hoisted_3
      ]),
      loading: _withCtx(() => [
        _hoisted_4
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          header: "",
          style: {"width":"1%"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Button, {
              type: "button",
              class: "p-button-text p-button-sm",
              icon: "pi pi-pencil",
              onClick: ($event: any) => (_ctx.onEditContext(data))
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Titulo",
          sortable: "",
          field: "name"
        }),
        _createVNode(_component_Column, {
          header: "Contexto",
          sortable: "",
          field: "key"
        }),
        _createVNode(_component_Column, {
          header: "",
          style: {"width":"1%"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-pencil",
              label: "Editar",
              onClick: ($event: any) => (_ctx.onEdit(data))
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "loading"]),
    _createVNode(_component_Dialog, {
      header: "Crear contexto",
      visible: _ctx.contextEditDialogVisibility,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.contextEditDialogVisibility = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Guardar",
          icon: "pi pi-check",
          onClick: _ctx.onSaveContext,
          disabled: !_ctx.isValidContextData,
          class: "p-m-0"
        }, null, 8, ["onClick", "disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_InputText, {
              id: "new-context-name",
              modelValue: _ctx.editingContext.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.editingContext.name = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_InputText, {
              id: "new-context-key",
              modelValue: _ctx.editingContext.key,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.editingContext.key = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}